import { Link } from "react-router-dom";

// Sharp-edged luxury button. variant: gold | outline-light | outline-dark
export const LuxButton = ({ children, to, href, variant = "gold", className = "", onClick, testid, type }) => {
  const base =
    "group relative inline-flex items-center justify-center px-9 py-4 text-xs font-semibold tracking-[0.2em] uppercase transition-colors duration-500 overflow-hidden";
  const variants = {
    gold: "bg-[#C1272D] text-[#0a0908] hover:bg-[#9E1F24]",
    "outline-light":
      "border border-white/40 text-white hover:text-[#0a0908]",
    "outline-dark":
      "border border-black/30 text-[#1a1817] hover:text-white",
    "solid-dark": "bg-[#0a0908] text-white hover:bg-[#161412]",
  };
  const fill = {
    "outline-light": "bg-white",
    "outline-dark": "bg-[#0a0908]",
  };

  const inner = (
    <>
      {(variant === "outline-light" || variant === "outline-dark") && (
        <span
          className={`absolute inset-0 origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] ${fill[variant]}`}
        />
      )}
      <span className="relative z-10">{children}</span>
    </>
  );

  const cls = `${base} ${variants[variant]} ${className}`;

  if (to) return <Link data-testid={testid} to={to} className={cls} onClick={onClick}>{inner}</Link>;
  if (href) return <a data-testid={testid} href={href} className={cls} onClick={onClick}>{inner}</a>;
  return <button data-testid={testid} type={type || "button"} className={cls} onClick={onClick}>{inner}</button>;
};
